/**
 * «Add to Home Screen» opens the manifest's start_url (/app, the client app). On the studio kiosk
 * (/v3, /v2, /) and the therapist tablet that put the phone app on the iPad (owner 27.10.2026: small
 * buttons on the kiosk). Outside /app the manifest is removed, so the icon opens the page it was
 * added from (e.g. /v3?location=parede&kiosk=1), still full screen (apple-mobile-web-app-capable).
 */
export function manifestOnlyForApp(doc: Document = document, path = window.location.pathname): void {
  if (path === '/app' || path.startsWith('/app/') || path === '/privacy') return;
  doc.querySelectorAll('link[rel="manifest"]').forEach((l) => l.remove());
  // iPad form (owner 28.10.2026): its own icon — 360°FACE on dark navy with a red «SURV» — named «SURV»
  if (path.startsWith('/anketa')) {
    doc.querySelector('meta[name="apple-mobile-web-app-title"]')?.setAttribute('content', 'SURV');
    doc.querySelector('link[rel="apple-touch-icon"]')?.setAttribute('href', '/anketa-touch-icon.png');
  }
}
